import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';

import PartyTabSection from '@/components/common/PartyTabSection';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import { PARTY_TAB_SECTIONS_MAX_ITEMS } from '@/features/party/constants';
import paths from '@/lib/paths';
import useLocalSettings from '@/stores/useLocalSettings';

import useClaims from '../../queries/hooks/useClaims';

import ClaimItem from './ClaimItem';

export default function ClaimsSection() {
  const { t } = useTranslation();

  const { onlyShowRelevant } = useLocalSettings();

  const party = useSelectedParty();
  const {
    analysis: {
      relevant: { claimIds },
    },
  } = useEmail();

  const { data: claims, isLoading } = useClaims(
    party?.id ?? '',
    { status: ['OPEN'] },
    {
      enabled: Boolean(party?.id),
    },
  );

  const shownItems = onlyShowRelevant
    ? claims?.filter((claim) => claimIds?.includes(claim.id))
    : claims?.slice(0, PARTY_TAB_SECTIONS_MAX_ITEMS);

  return (
    <PartyTabSection
      icon={ShieldAlert}
      title={t('SIDEBAR_RECENT_CLAIMS')}
      noItemsMessage={t('CLAIMS_NONE_OPEN')}
      more={generatePath(paths.claims.overview)}
      isLoading={isLoading}
      totalItems={claims?.length ?? 0}
      relevantItems={claimIds?.length ?? 0}
    >
      {shownItems?.map((claim) => (
        <ClaimItem key={claim.id} claim={claim} />
      ))}
    </PartyTabSection>
  );
}
